module.exports = __webpack_public_path__ + "media/images/social-icon-4-4bab192c1c06263007a2ae04f76a299f.png";